import PropTypes from 'prop-types';

import ZillowInsuranceServicesLogo from '../../ZillowInsuranceServicesLogo';
import { Box, Modal, Paragraph, Text, TextButton } from '@zillow/constellation-10';

import ModalFooter from '../ModalFooter';

import { RENTAL_PROTECTION_DETAILS_COVERAGE_LINK } from '../../../containers/RentGuaranteePage/constants';

import ExpandableDisclaimerWithData from '../../rentGuarantee/components/ExpandableDisclaimerWithData';
import RentGuaranteeSelectionsContent from '../../rentGuarantee/components/RentGuaranteeSelectionsContent';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  onDropRentalProtectionClick: PropTypes.func.isRequired,
  premium: PropTypes.number.isRequired,
  monthlyRent: PropTypes.number.isRequired,
  isSecurityDepositWaived: PropTypes.bool.isRequired,
  securityDepositAmount: PropTypes.number.isRequired,
  showDropRentalProtectionRequestLink: PropTypes.bool,
};

const defaultProps = {};

const RentalProtectionSelectionsModal = ({
  onClose,
  onDropRentalProtectionClick,
  premium,
  monthlyRent,
  isSecurityDepositWaived,
  securityDepositAmount,
  showDropRentalProtectionRequestLink = true,
}) => {
  const landlordReceiptAmount = monthlyRent - premium;

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<ZillowInsuranceServicesLogo />}
      footer={<ModalFooter submitText="Okay" onSubmit={onClose} />}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <Box css={{ padding: { xs: '200', md: '600' } }} data-testid="RentalProtectionSelectionsModal">
          <div data-testid="HeaderContainer">
            <Paragraph css={{ textStyle: 'heading-sm', marginBottom: '400' }}>
              Your Rental Protection selections
            </Paragraph>
            <Paragraph>
              You started a request for Rental Protection. For more information about details and coverage,{' '}
              <TextButton asChild>
                <a href={RENTAL_PROTECTION_DETAILS_COVERAGE_LINK} target="_blank" rel="noopener noreferrer">
                  click here.
                </a>
              </TextButton>
            </Paragraph>
          </div>
          <div data-testid="SelectionsContainer">
            <RentGuaranteeSelectionsContent
              premium={premium}
              monthlyRent={monthlyRent}
              landlordReceiptAmount={landlordReceiptAmount}
              isSecurityDepositWaived={isSecurityDepositWaived}
              securityDepositAmount={securityDepositAmount}
            />
          </div>
          {showDropRentalProtectionRequestLink ? (
            <Box data-testid="CTAContainer" css={{ marginBottom: '600' }}>
              <Text>
                No longer interested?{' '}
                <TextButton onClick={onDropRentalProtectionClick}>Drop Rental Protection request</TextButton>
              </Text>
            </Box>
          ) : (
            <Box css={{ marginBottom: '400' }} />
          )}

          <ExpandableDisclaimerWithData displaySurplusTaxesAndFees={true} />
        </Box>
      }
    />
  );
};

RentalProtectionSelectionsModal.propTypes = propTypes;
RentalProtectionSelectionsModal.defaultProps = defaultProps;

export default RentalProtectionSelectionsModal;
